<template>
    <div>
        <Layout>
            <div class="search-main main">
                <section class="recent_course">
                    <SearchResultItem :items="items"/>
                </section>
            </div>
        </Layout>
    </div>
</template>
<script>
    import SearchResultItem from './SearchResultItem'

    export default {
        name: "ClassSearchResult",
        components:{SearchResultItem},
        computed: {},
        props:{
            items:Array
        },
        data() {
            return {}
        },
        watch: {},
        mounted() {
            // 加载跳转到顶部
            window.scrollTo(0, 0)
        },
        methods: {},
    }
</script>
<style lang="scss" scoped>
    .main {
        margin: auto;
        .search-title {
            font-size: 16px;
            font-weight: 400;
            color: rgba(33, 33, 33, 1);
            margin-bottom: 40px;
            position: relative;
            left: -10px;
            font-family: PingFangSC-Regular, PingFang SC;
        }

        .search-result-number {
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #4a4a4a;
        }

        .recent_course {
            min-width: 960px;
            max-width: 1040px;
            margin: 10px auto;
        }

        /deep/ .ivu-page {
            text-align: center;
        }

        /deep/ .ivu-row {
            min-height: 300px;
        }

        /deep/ .ivu-page-item-active {
            border-color: #ED6C00;

            a {
                color: #ED6C00;
            }
        }

        /deep/ .ivu-page-item {
            &:hover {
                border-color: #ED6C00;

                a {
                    color: #ED6C00;
                }
            }
        }

        /deep/ .ivu-page-prev, /deep/ .ivu-page-next {
            &:not(.ivu-page-disabled) {
                &:hover {
                    border-color: #ED6C00;

                    a {
                        color: #ED6C00;
                    }
                }
            }
        }

        /deep/ .ivu-spin-dot {
            background-color: #ED6C00;
        }
    }
</style>
